import { COUNTRY_CODES } from '@/constants/country-codes';
import { PAYMENT_METHOD_ID } from '@/core/payment-methods/constants';

export const AUSTRIA_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const BELGIUM_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const BULGARIA_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const CROATIA_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const CYPRUS_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const CZECH_REPUBLIC_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const DENMARK_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const FINLAND_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const FRANCE_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const GERMANY_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const GREAT_BRITAIN_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const GREECE_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24
];

export const HUNGARY_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const IRELAND_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const ITALY_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.BancomatPay,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const LUXEMBOURG_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const MALTA_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const NETHERLANDS_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const POLAND_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.BlikDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const PORTUGAL_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const ROMANIA_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const SPAIN_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];
export const SWEDEN_PAYMENT_METHOD_LIST_ORDER: Array<PAYMENT_METHOD_ID> = [
    PAYMENT_METHOD_ID.GooglePay,
    PAYMENT_METHOD_ID.ApplePay,
    PAYMENT_METHOD_ID.SamsungPay,
    PAYMENT_METHOD_ID.Swish,
    PAYMENT_METHOD_ID.Trustly,
    PAYMENT_METHOD_ID.PaymentInitiation,
    PAYMENT_METHOD_ID.CreditCard,
    PAYMENT_METHOD_ID.PayPal,
    PAYMENT_METHOD_ID.Klarna,
    PAYMENT_METHOD_ID.PayOnDelivery,
    PAYMENT_METHOD_ID.WeChatPay,
    PAYMENT_METHOD_ID.BitPay,
    PAYMENT_METHOD_ID.BancontactQRCode,
    PAYMENT_METHOD_ID.Iris,
    PAYMENT_METHOD_ID.TbiBnpl,
    PAYMENT_METHOD_ID.IDeal,
    PAYMENT_METHOD_ID.Multibanco,
    PAYMENT_METHOD_ID.MobilePay,
    PAYMENT_METHOD_ID.MultibancoWay,
    PAYMENT_METHOD_ID.MultibancoReference,
    PAYMENT_METHOD_ID.Eps,
    PAYMENT_METHOD_ID.Payconiq,
    PAYMENT_METHOD_ID.GiroPay,
    PAYMENT_METHOD_ID.GiroPayDirect,
    PAYMENT_METHOD_ID.Blik,
    PAYMENT_METHOD_ID.DirectDebit,
    PAYMENT_METHOD_ID.Satispay,
    PAYMENT_METHOD_ID.Wallet,
    PAYMENT_METHOD_ID.DirectPay,
    PAYMENT_METHOD_ID.P24,
    PAYMENT_METHOD_ID.PayU,
    PAYMENT_METHOD_ID.BlueCode,
    PAYMENT_METHOD_ID.Dias,
    PAYMENT_METHOD_ID.Cash
];

export const PAYMENT_METHOD_LIST_ORDER_BY_COUNTRY = {
    [COUNTRY_CODES.Austria]: AUSTRIA_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Belgium]: BELGIUM_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Bulgarian]: BULGARIA_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Croatia]: CROATIA_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Cyprus]: CYPRUS_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.CzechRepublic]: CZECH_REPUBLIC_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Denmark]: DENMARK_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Finland]: FINLAND_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.France]: FRANCE_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Germany]: GERMANY_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.GreatBritain]: GREAT_BRITAIN_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Greek]: GREECE_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Hungary]: HUNGARY_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Ireland]: IRELAND_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Italy]: ITALY_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Luxembourg]: LUXEMBOURG_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Malta]: MALTA_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Netherlands]: NETHERLANDS_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Poland]: POLAND_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Portugal]: PORTUGAL_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Romania]: ROMANIA_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Spain]: SPAIN_PAYMENT_METHOD_LIST_ORDER,
    [COUNTRY_CODES.Sweden]: SWEDEN_PAYMENT_METHOD_LIST_ORDER
};
